import React from "react";

import Select from "react-select";

import { useTranslation } from "react-i18next";

import { useBibliotecaContext } from "../../context/BibliotecaContext";

export function SumariosFilter() {
    const { t } = useTranslation();
    const { sumariosData, sumariosSelecionados, setSumariosSelecionados } = useBibliotecaContext();

    const options = sumariosData
        ? sumariosData.map((sumario) => ({
            label: sumario.nome,
            value: sumario.id,
        }))
        : [];

    const selectedOptions = options.filter((option) =>
        sumariosSelecionados.includes(option.value)
    );

    return (
        <div className="mt-4">
            <div className="mb-2">{t("biblioteca.taxTypes")}</div>

            <Select
                value={selectedOptions}
                isMulti
                isSearchable
                name="sumario"
                options={options}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={(selected) => setSumariosSelecionados(
                    selected ? selected.map((option) => option.value) : []
                )}
                placeholder={t("biblioteca.selectTaxType")}
                noOptionsMessage={() => t("biblioteca.emptyTaxTypes")}
            />
        </div>
    );
}
